<template>
  <div class="exam-notice">
    <div v-if="this.currentExamInfo.id" v-html="regNotice"></div>
    <div v-else
      style=" display: flex; justify-content: center; align-items: center; flex-direction: column;min-height: calc(100vh - 120px);">
      <div class="print-btn">
        <i class="el-icon-circle-close" style="font-size: 66px;"></i>
      </div>
      <div style="margin-top: 30px;">暂无考试可报名！</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      content: "",
    };
  },
  computed: {
    ...mapGetters(["currentExamInfo"]),
    regNotice() {
      console.log(this.currentExamInfo, 'this.currentExamInfo');

      return this.currentExamInfo.regNotice;
    },
  },
  async created() {
    await this.fetchExamInfoById();
  },
  methods: {
    ...mapActions(["fetchExamInfoById", "fetchExamDataList"]),
  }

};
</script>

<style scoped lang="scss">
.exam-notice {
  padding: 20px 30px;
}

.print-btn {
  width: 88px;
  height: 88px;
  background: #f5f7fa;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .exam-notice {
    padding: 16px;

    ::v-deep img {
      max-width: 100%;
      height: auto;
    }

    ::v-deep table {
      width: 100%;
      overflow-x: auto;
      display: block;
    }
  }

  .print-btn {
    width: 72px;
    height: 72px;

    i {
      font-size: 48px !important;
    }
  }
}
</style>
